import { render, staticRenderFns } from "./MissingDocumentCard.vue?vue&type=template&id=636cde01&scoped=true"
import script from "./MissingDocumentCard.vue?vue&type=script&lang=ts"
export * from "./MissingDocumentCard.vue?vue&type=script&lang=ts"
import style0 from "./MissingDocumentCard.vue?vue&type=style&index=0&id=636cde01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636cde01",
  null
  
)

export default component.exports